import { render, staticRenderFns } from "./ModalPaymentAccount.vue?vue&type=template&id=4442a500&"
import script from "./ModalPaymentAccount.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports